import { autoinject } from "aurelia-framework";
import { ProcoreDeleteDirectCostFilters } from "./procore-delete-direct-cost-filters";
import { ProcoreTransactionFilters } from "./procore-transaction-filters";

@autoinject
export class ProcoreFilters {
  constructor(public readonly transactionFilters: ProcoreTransactionFilters,
              public readonly deleteDirectCostFilters: ProcoreDeleteDirectCostFilters) {  }
}
